import React, { ComponentProps } from 'react'
import { useAnalytics } from '../../application/analytics'
import { buildEvent } from '../../application/analytics/eventBuilders'
import { SingleQuestion } from '../SingleQuestion/SingleQuestion'

type Props = Omit<ComponentProps<typeof SingleQuestion>, 'onToggleReadMore'>

export const SingleQuestionWithAnalytics: React.FC<Props> = (props) => {
  const { readMoreVariant } = props
  const { trackEvent } = useAnalytics()

  const onToggleReadMore = (isReadMoreOpen: boolean) =>
    trackEvent(buildEvent.clickReadMoreButton(isReadMoreOpen, readMoreVariant))

  return <SingleQuestion {...props} onToggleReadMore={onToggleReadMore} />
}
